const ENGAGEMENT = 'engagement';

export { ENGAGEMENT };

const isEnabled = (feature, { company }) => {
  const { disabledFeatures = [] } = company || {};
  return !disabledFeatures.includes(feature);
}

export default isEnabled;